import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Login from './pages/Login';
import Layout from './components/Layout';
import ResourceCenter from './pages/ResourceCenter';
import ResourceDetail from './pages/ResourceDetail';
import Manifesto from './pages/Manifesto';
import Opportunities from './pages/Opportunities';
import Partners from './pages/Partners';
import TheCompetition from './pages/TheCompetition';
import ScrollToTop from './components/ScrollToTop';
import JoinPage from './pages/JoinPage';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* ✅ Add this here! */}
      <Layout>
        <Routes>
          <Route
            path="/"
            element={<Home />}
          />
          <Route
            path="/about"
            element={<About />}
          />

          <Route
            path="/join"
            element={<JoinPage />}
          />
          <Route
            path="/login"
            element={<Login />}
          />
          <Route
            path="/resources"
            element={<ResourceCenter />}
          />
          <Route
            path="/manifesto"
            element={<Manifesto />}
          />
          <Route
            path="/thecompetition"
            element={<TheCompetition />}
          />
          <Route
            path="/opportunities"
            element={<Opportunities />}
          />
          <Route
            path="/partners"
            element={<Partners />}
          />
          <Route
            path="/resource/:slug"
            element={<ResourceDetail />}
          />
          <Route
            path="/contact"
            element={<Contact />}
          />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
